var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2083 4.59235C19.1108 12.2191 14.454 17.4436 7.50225 17.7728C4.63575 17.9101 2.55825 16.9403 0.75 15.7366C2.86875 16.0921 5.4975 15.2041 6.90225 13.9448C4.82475 13.7333 3.59475 12.6263 3.0195 10.8443C3.62025 10.9516 4.2525 10.9246 4.82325 10.7971C2.94825 10.1401 1.61025 8.92735 1.5405 6.38485C2.06625 6.63535 2.61525 6.8701 3.34275 6.9166C1.9395 6.0811 0.903 3.0271 2.091 1.00735C4.17225 3.3961 6.67575 5.34685 10.788 5.6116C9.756 0.989348 15.6038 -1.51715 18.051 1.58935C19.0853 1.3801 19.9275 0.968348 20.7383 0.521348C20.4038 1.59535 19.7617 2.34385 18.9795 2.9446C19.8382 2.8231 20.6003 2.60335 21.249 2.26735C20.847 3.1426 19.965 3.9301 19.2075 4.59235H19.2083Z",
    fill: "#191919"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.02cae8fb4528270eea5b804fa2fc9615.svg";